import { StyleSheet } from 'react-native';
import { textLatoStyleDS } from 'src/theme-v2/text';
import { TextLinkTheme } from 'src/theme-v2/text-link';

export const styles = StyleSheet.create({
  button: {
    flexGrow: 0,
  },
  buttonHover: {},
  buttonDisabled: {},
  buttonSmall: { minWidth: 44, minHeight: 44, flexDirection: 'row' },
  buttonDefault: { minWidth: 44, minHeight: 44, flexDirection: 'row' },
  buttonInnerSmall: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    gap: 4,
  },
  buttonInnerDefault: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    gap: 4,
  },
  iconHover: { color: TextLinkTheme.TextLinkIconHover },
  iconDisabled: { color: TextLinkTheme.TextLinkIconDisable },
  iconSmall: {
    height: 16,
    width: 16,
    color: TextLinkTheme.TextLinkIconDefault,
  },
  iconDefault: {
    height: 16,
    width: 16,
    color: TextLinkTheme.TextLinkIconDefault,
  },
  textHover: { color: TextLinkTheme.TextLinkTextHover },
  textDisabled: { color: TextLinkTheme.TextLinkTextDisable },
  textSmall: {
    color: TextLinkTheme.TextLinkTextDefault,
    ...textLatoStyleDS.BodyBoldSm,
  },
  textDefault: {
    color: TextLinkTheme.TextLinkTextDefault,
    ...textLatoStyleDS.BodyBoldMd,
  },
});
